<template>
  <div class="reg-auth-forgot__header">
    <img
      v-if="!noLogo"
      src="/img/logo/logo-mini.svg"
      alt="BETON logo"
      width="48px"
      height="48px"
      class="reg-auth-forgot__logo"
    />
    <UiBtn
      v-if="withGoBack"
      class="reg-auth-forgot__btn"
      color="line"
      icon-only
      size="s"
      icon="chevrons/chevron-left"
      @click="goBack"
    />
    <UiText
      :text="title"
      tag="span"
      font="body-heading-1"
      color="typography-title01"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RegAuthForgotTitle',
  props: {
    name: { type: String, require: true },
    withGoBack: { type: Boolean, default: true },
    sumBonuses: { type: Number, require: false },
    noLogo: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('login', ['get_resultPasswordChange']),
    title() {
      if (this.name === 'auth') {
        return this.$t('regAuthForgot.header.auth')
      }
      else if (this.name === 'registration') {
        return this.$t('regAuthForgot.header.registration')
      }
      else if (this.name === 'registrationBonuses') {
        return `${this.$t('regAuthForgot.regBonus.chooseBonus')} (${this.sumBonuses})`
      }
      else if (this.name === 'resetPassword' && !this.get_resultPasswordChange) {
        return this.$t('regAuthForgot.header.resetPassword')
      }
      else {
        return this.$t('regAuthForgot.header.passwordRecovery')
      }
    },
  },
  methods: {
    goBack() {
      this.$newModal.changeQueryParam('bigModal', 'auth')
    },
  },
}
</script>
<style lang="scss" scoped src="./style.scss"></style>
